import { schema } from 'normalizr';

const userSchema = new schema.Entity('users');
const awardSchema = new schema.Entity('awards');
const infoSchema = new schema.Entity('info');
const categorySchema = new schema.Entity('categories');
const workPhotoSchema = new schema.Entity('work_photos');
const workSchema = new schema.Entity(
  'works',
  {
    work_photos: [workPhotoSchema]
  },
  { idAttribute: 'slug' }
);
const instagramSchema = new schema.Entity('instagram');

// Schemas for Github API responses.
export default {
  USER: { data: userSchema },
  USER_ARRAY: { data: [userSchema] },
  AWARD: { data: awardSchema },
  AWARD_ARRAY: { data: [awardSchema] },
  INFO: { data: infoSchema },
  CATEGORY: { data: categorySchema },
  CATEGORY_ARRAY: { data: [categorySchema] },
  WORK: { data: workSchema },
  WORK_ARRAY: { data: [workSchema] },
  INSTAGRAM_ARRAY: { data: [instagramSchema] }
};



// WEBPACK FOOTER //
// ./src/redux/models/index.js